import {
  Button,
  Checkbox,
  Col,
  Descriptions,
  Modal,
  QRCode,
  Row,
  Typography,
} from "antd";
import { HeaderPrintForm } from "components/common";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import ReactToPrint from "react-to-print";

import { formatDateToString, formatToCurrencyType } from "helper/common";
import { FORMAT_TIME } from "types/enums";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import "./PhieuChiDinhXetNghiem.scss";
import { useAppSelector } from "redux/hooks";
import { InfoItem } from "components/common/PrintForm";

const catalogNDV = {
  xetNghiem: ["Huyết học", "Sinh hóa", "Vi sinh", "Nước tiểu"],
  CDHA: ["Chẩn đoán hình ảnh", "Điện tim", "Thăm dò chức năng"],
  dienTim: ["Điện tim"],
  PTTT: ["Phẫu thuật", "Thủ thuật"],
};

const PhieuChiDinhXetNghiem = (props) => {
  const { closeModal } = props;
  const printRef2 = useRef<any>();
  const dataPhieu = useAppSelector((e) => e.residentialNurse.dataPhieu);
  console.log("🚀 ~ PhieuChiDinhXetNghiem ~ dataPhieu:", dataPhieu);

  const thongTinBN = useAppSelector((e) => e.residentialNurse.thongTinBN);
  console.log("🚀 ~ PhieuChiDinhXetNghiem ~ thongTinBN:", thongTinBN);

  const fields1 = [
    { label: "Họ và tên", value: thongTinBN?.tenBenhNhan },
    {
      label: "Ngày sinh",
      value: formatDateToString(thongTinBN?.ngaySinh, FORMAT_TIME.dayFull),
    },
  ];
  const fields2 = [
    { label: "Mã bệnh nhân", value: thongTinBN?.maBenhNhan },
    { label: "Mã phiếu khám", value: thongTinBN?.maPhieuKham },
  ];
  const fields3 = [
    {
      label: "Giới tính",
      value:
        gioiTinhOptions.find((it) => it.value === thongTinBN?.gioiTinh)
          ?.label || "--",
    },
    {
      label: "Địa chỉ",
      value: thongTinBN?.diaChi,
    },
    { label: "Số thẻ BHYT", value: thongTinBN?.soTheBaoHiemYTe },
    { label: "Nơi KCB ban đầu", value: thongTinBN?.noiDangKyKhamBanDau },
    {
      label: "Chẩn đoán",
      value:
        (dataPhieu?.icdChanDoan ? dataPhieu?.icdChanDoan + " - " : "") +
        dataPhieu?.chanDoan,
    },
  ];
  const [dsNhomChiDinhXN, setDsNhomChiDinhXN] = useState<any>([]);
  const [dsNhomChiDinhCDHA, setDsNhomChiDinhCDHA] = useState<any>([]);
  const [dsNhomChiDinhPTTT, setDsNhomChiDinhPTTT] = useState<any>([]);
  const getTongTien = (ds) => {
    let res = 0;
    ds.map((dt) =>
      dt.chiDinhDtos.map((it) => {
        res += it.thanhTien;
      })
    );
    return res;
  };
  useEffect(() => {
    if (dataPhieu?.toDieuTriDtoList) {
      let xnindex = 0;
      let cdhaindex = 0;
      let xn = [];
      let cdha = [];
      let pttt = [];
      let tt = [];
      let pt = [];
      dataPhieu?.toDieuTriDtoList.map((it) => {
        it.phieuChiDinhDtos.map((dt) => {
          xn = [
            ...xn,
            ...dt.nhomChiDinhDtos
              .filter((et) => catalogNDV.xetNghiem.includes(et.tenNhomChiDinh))
              .map((ft) => {
                let tmp = ft.chiDinhDtos.filter((gt) => gt.idLoaiDV === 3);
                let idx = xnindex;
                xnindex += tmp.length;
                return { ...ft, chiDinhDtos: tmp, index: idx };
              }),
          ];
          cdha = [
            ...cdha,
            ...dt.nhomChiDinhDtos
              .filter((et) => catalogNDV.CDHA.includes(et.tenNhomChiDinh))
              .map((ft) => {
                let tmp = ft.chiDinhDtos.filter((gt) => gt.idLoaiDV === 0);
                let idx = cdhaindex;
                cdhaindex += tmp.length;
                return { ...ft, chiDinhDtos: tmp, index: idx };
              }),
          ];

          dt.nhomChiDinhDtos
            .filter((et) => et.tenNhomChiDinh == "Phẫu thuật")
            .map((ft) =>
              ft.chiDinhDtos.map((gt) => {
                if (gt.idLoaiDV === 1) {
                  pt = [...pt, { ...gt }];
                }
              })
            );

          dt.nhomChiDinhDtos.map((ft) =>
            ft.chiDinhDtos.map((gt) => {
              if (gt.idLoaiDV === 1 && ft.tenNhomChiDinh != "Phẫu thuật") {
                tt = [...tt, { ...gt }];
              }
            })
          );
        });
      });
      pttt = [
        {
          tenNhomChiDinh: "Phẫu thuật",
          chiDinhDtos: pt,
          index: 0,
        },
        {
          tenNhomChiDinh: "Thủ thuật",
          chiDinhDtos: tt,
          index: pt.length,
        },
      ];
      setDsNhomChiDinhXN(xnindex > 0 ? xn : []);
      setDsNhomChiDinhCDHA(cdhaindex > 0 ? cdha : []);
      setDsNhomChiDinhPTTT(pttt);
    }
  }, [dataPhieu]);
  const onPrint = async () => {
    window.print();
  };
  const cloneToPrint = () => {
    return printRef2.current;
  };
  const handleCheckPrint = (className, show, type) => {
    const emptyNode = document.createElement("div");
    emptyNode.setAttribute("class", className);

    let printNode;

    if (show === true) {
      printNode =
        document
          .querySelectorAll(`div.preview div.${className}`)?.[0]
          ?.cloneNode(true) || emptyNode;
    } else {
      printNode = emptyNode;
    }

    const originNode = document.querySelectorAll(
      `div.print div.${className}`
    )?.[0];
    const printContent = document.getElementById("print-content");

    printContent.replaceChild(printNode, originNode);
  };

  useEffect(() => {
    handleCheckPrint("xetNghiem", true, 1);
    handleCheckPrint("cdha", true, 2);
    handleCheckPrint("pttt", true, 3);
  }, [thongTinBN, dataPhieu, dsNhomChiDinhXN]);

  const getDay = (time) => {
    return time
      ? dayjs(time).format(`Ngày DD [tháng] MM [năm] YYYY`)
      : dayjs().format(`Ngày DD [tháng] MM [năm] YYYY`);
  };
  return (
    <Row>
      <div className=" phieu-chi-dinh-noi-tru">
        <div className="preview">
          {dsNhomChiDinhXN?.length > 0 ? (
            <>
              <Checkbox
                className="check-box"
                style={{ textAlign: "center" }}
                defaultChecked={true}
                onChange={(e) =>
                  handleCheckPrint("xetNghiem", e.target.checked, 1)
                }
              ></Checkbox>
              {/* <div style={{ pageBreakBefore: "always" }}></div> */}

              <div
                className="xetNghiem"
                id="xn"
                style={{
                  pageBreakBefore: "always",
                  padding: "0px 20px 15px 50px",
                }}
              >
                <table>
                  <thead>
                    <tr style={{ height: "15px", borderCollapse: "collapse" }}>
                      <td></td>
                    </tr>

                    <tr>
                      <td style={{ height: "15px" }}>
                        <HeaderPrintForm></HeaderPrintForm>
                      </td>
                    </tr>
                    <tr style={{ height: "15px", borderCollapse: "collapse" }}>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <div style={{ paddingLeft: 24, paddingRight: 24 }}>
                      <div style={{ marginBottom: 8 }}>
                        <InfoItem
                          h2={true}
                          fields1={fields1}
                          fields2={fields2}
                          idBenhNhan={thongTinBN?.maBenhNhan}
                          title={"PHIẾU CHỈ ĐỊNH XÉT NGHIỆM"}
                          isChiefComplant={false}
                          fields3={fields3}
                          qr={false}
                        />
                      </div>
                      <div className="my-table-custom">
                        <table>
                          <thead>
                            <tr>
                              <th style={{ width: "8%" }}>
                                <Typography.Text strong>STT</Typography.Text>
                              </th>
                              <th style={{ width: "50%" }}>
                                <Typography.Text strong>
                                  Tên dịch vụ
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%" }}>
                                <Typography.Text strong>
                                  Số lượng
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%" }}>
                                <Typography.Text strong>
                                  Đơn giá
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%" }}>
                                <Typography.Text strong>
                                  Thành tiền
                                </Typography.Text>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {dsNhomChiDinhXN?.map((it) => {
                              return (
                                <>
                                  <tr>
                                    <td colSpan={5}>
                                      <Typography.Text strong>
                                        {it.tenNhomChiDinh}
                                      </Typography.Text>
                                    </td>
                                  </tr>
                                  {it.chiDinhDtos.map((dt, idx) => {
                                    return (
                                      <tr>
                                        <td className="ta-c">
                                          <Typography.Text>
                                            {it.index + idx + 1}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-l pdrl-4">
                                          <Typography.Text>
                                            {dt.tenChiDinh}
                                          </Typography.Text>
                                        </td>
                                        <td
                                          className="ta-r"
                                          style={{ textAlign: "center" }}
                                        >
                                          <Typography.Text>
                                            {dt.soLuong}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-r">
                                          <Typography.Text>
                                            {formatToCurrencyType(dt.donGia)}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-r">
                                          <Typography.Text>
                                            {formatToCurrencyType(dt.thanhTien)}
                                          </Typography.Text>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </>
                              );
                            })}
                            <tr>
                              <td className="ta-c" colSpan={4}>
                                <Typography.Text strong>
                                  Tổng tiền
                                </Typography.Text>
                              </td>
                              <td
                                className="ta-r"
                                style={{ fontWeight: "bold" }}
                              >
                                <Typography.Text>
                                  {formatToCurrencyType(
                                    getTongTien(dsNhomChiDinhXN)
                                  )}
                                </Typography.Text>
                              </td>
                              {/* <td></td>
                          <td></td>
                          <td></td> */}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <Row
                        justify={"space-between"}
                        style={{ marginTop: "24px", marginRight: "24px" }}
                      >
                        <Col></Col>
                        <Col>
                          <Row justify={"center"}>
                            <Typography.Text>
                              {getDay(
                                dsNhomChiDinhXN?.[0]?.chiDinhDtos?.[0]?.thoiGian
                              )}
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text strong>
                              Bác sĩ điều trị
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text type="secondary">
                              (Ký và ghi rõ họ tên)
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"} style={{ marginTop: "48px" }}>
                            <Typography.Text strong>
                              {thongTinBN?.tenBacSiDieuTri}
                            </Typography.Text>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td
                        style={{ borderCollapse: "collapse", height: "20px" }}
                      ></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
          ) : null}

          {dsNhomChiDinhCDHA?.length > 0 ? (
            <>
              <Checkbox
                className="check-box"
                defaultChecked={true}
                onChange={(e) => handleCheckPrint("cdha", e.target.checked, 2)}
              ></Checkbox>
              <div
                className="cdha"
                id="cdha"
                style={{
                  padding: "0px 20px 15px 50px",
                  pageBreakBefore: "always",
                }}
              >
                <table>
                  <thead>
                    <tr style={{ height: "15px", borderCollapse: "collapse" }}>
                      <td></td>
                    </tr>

                    <tr>
                      <td style={{ height: "15px" }}>
                        <HeaderPrintForm></HeaderPrintForm>
                      </td>
                    </tr>
                    <tr style={{ height: "15px", borderCollapse: "collapse" }}>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <div
                      className=""
                      style={{ paddingLeft: 24, paddingRight: 24 }}
                    >
                      <div className="container1" style={{ marginBottom: 8 }}>
                        <InfoItem
                          h2={true}
                          fields1={fields1}
                          fields2={fields2}
                          idBenhNhan={thongTinBN?.maBenhNhan}
                          title={"PHIẾU CHỈ ĐỊNH CĐHA"}
                          isChiefComplant={false}
                          qr={false}
                          fields3={fields3}
                        />
                      </div>
                      <div className="my-table-custom">
                        <table>
                          <thead>
                            <tr>
                              <th style={{ width: "8%" }}>
                                <Typography.Text strong>STT</Typography.Text>
                              </th>
                              <th style={{ width: "50%" }}>
                                <Typography.Text strong>
                                  Tên dịch vụ
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%", textAlign: "center" }}>
                                <Typography.Text strong>
                                  Số lượng
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%" }}>
                                <Typography.Text strong>
                                  Đơn giá
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%" }}>
                                <Typography.Text strong>
                                  Thành tiền
                                </Typography.Text>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan={5}>
                                <Typography.Text strong>
                                  {"Thăm dò chức năng"}
                                </Typography.Text>
                              </td>
                            </tr>
                            {dsNhomChiDinhCDHA?.map((it) => {
                              return (
                                <>
                                  {it.chiDinhDtos.map((dt, idx) => {
                                    return (
                                      <tr>
                                        <td className="ta-c">
                                          <Typography.Text>
                                            {it.index + idx + 1}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-l pdrl-4">
                                          <Typography.Text>
                                            {dt.tenChiDinh}
                                          </Typography.Text>
                                        </td>
                                        <td
                                          className="ta-r"
                                          style={{ textAlign: "center" }}
                                        >
                                          <Typography.Text>
                                            {dt.soLuong}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-r">
                                          <Typography.Text>
                                            {formatToCurrencyType(dt.donGia)}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-r">
                                          <Typography.Text>
                                            {formatToCurrencyType(dt.thanhTien)}
                                          </Typography.Text>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </>
                              );
                            })}
                            <tr>
                              <td className="ta-c" colSpan={4}>
                                <Typography.Text strong>
                                  Tổng tiền
                                </Typography.Text>
                              </td>
                              <td
                                className="ta-r"
                                style={{ fontWeight: "bold" }}
                              >
                                <Typography.Text>
                                  {formatToCurrencyType(
                                    getTongTien(dsNhomChiDinhCDHA)
                                  )}
                                </Typography.Text>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <Row
                        justify={"space-between"}
                        style={{ marginTop: "24px", marginRight: "24px" }}
                      >
                        <Col></Col>
                        <Col>
                          <Row justify={"center"}>
                            <Typography.Text>
                              {getDay(
                                dsNhomChiDinhCDHA?.[0]?.chiDinhDtos?.[0]
                                  ?.thoiGian
                              )}
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text strong>
                              Bác sĩ điều trị
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text type="secondary">
                              (Ký và ghi rõ họ tên)
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"} style={{ marginTop: "48px" }}>
                            <Typography.Text strong>
                              {thongTinBN?.tenBacSiDieuTri}
                            </Typography.Text>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td
                        style={{ borderCollapse: "collapse", height: "20px" }}
                      ></td>
                    </tr>
                  </tfoot>
                </table>
                {/* <div style={{ pageBreakAfter: "avoid" }}></div> */}
              </div>
            </>
          ) : null}

          {dsNhomChiDinhPTTT?.length > 0 ? (
            <>
              <Checkbox
                className="check-box"
                defaultChecked={true}
                onChange={(e) => handleCheckPrint("pttt", e.target.checked, 3)}
              ></Checkbox>
              <div
                className="pttt"
                id="pttt"
                style={{
                  padding: "0px 20px 15px 50px",
                  pageBreakBefore: "always",
                }}
              >
                <div style={{}}></div>

                <table>
                  <thead>
                    <tr style={{ height: "15px", borderCollapse: "collapse" }}>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        <HeaderPrintForm></HeaderPrintForm>
                      </td>
                    </tr>
                    <tr style={{ height: "15px", borderCollapse: "collapse" }}>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <div
                      className=""
                      style={{ paddingLeft: 24, paddingRight: 24 }}
                    >
                      <div className="container1" style={{ marginBottom: 8 }}>
                        <InfoItem
                          h2={true}
                          fields1={fields1}
                          fields2={fields2}
                          idBenhNhan={thongTinBN?.maBenhNhan}
                          title={"PHIẾU CHỈ ĐỊNH PHẪU THUẬT, THỦ THUẬT"}
                          isChiefComplant={false}
                          qr={false}
                          fields3={fields3}
                        />
                      </div>
                      <div className="my-table-custom">
                        <table>
                          <thead>
                            <tr>
                              <th style={{ width: "8%" }}>
                                <Typography.Text strong>STT</Typography.Text>
                              </th>
                              <th style={{ width: "50%" }}>
                                <Typography.Text strong>
                                  Tên dịch vụ
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%", textAlign: "center" }}>
                                <Typography.Text strong>
                                  Số lượng
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%" }}>
                                <Typography.Text strong>
                                  Đơn giá
                                </Typography.Text>
                              </th>
                              <th style={{ width: "14%" }}>
                                <Typography.Text strong>
                                  Thành tiền
                                </Typography.Text>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {dsNhomChiDinhPTTT?.map((it) => {
                              return (
                                <>
                                  {it?.chiDinhDtos?.length > 0 && (
                                    <tr>
                                      <td colSpan={5}>
                                        <Typography.Text strong>
                                          {it.tenNhomChiDinh}
                                        </Typography.Text>
                                      </td>
                                    </tr>
                                  )}
                                  {it.chiDinhDtos.map((dt, idx) => {
                                    return (
                                      <tr>
                                        <td className="ta-c">
                                          <Typography.Text>
                                            {it.index + idx + 1}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-l pdrl-4">
                                          <Typography.Text>
                                            {dt.tenChiDinh}
                                          </Typography.Text>
                                        </td>
                                        <td
                                          className="ta-r"
                                          style={{ textAlign: "center" }}
                                        >
                                          <Typography.Text>
                                            {dt.soLuong}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-r">
                                          <Typography.Text>
                                            {formatToCurrencyType(dt.donGia)}
                                          </Typography.Text>
                                        </td>
                                        <td className="ta-r">
                                          <Typography.Text>
                                            {formatToCurrencyType(dt.thanhTien)}
                                          </Typography.Text>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </>
                              );
                            })}
                            <tr>
                              <td className="ta-c" colSpan={4}>
                                <Typography.Text strong>
                                  Tổng tiền
                                </Typography.Text>
                              </td>
                              <td
                                className="ta-r"
                                style={{ fontWeight: "bold" }}
                              >
                                <Typography.Text>
                                  {formatToCurrencyType(
                                    getTongTien(dsNhomChiDinhPTTT)
                                  )}
                                </Typography.Text>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <Row
                        justify={"space-between"}
                        style={{ marginTop: "24px", marginRight: "24px" }}
                      >
                        <Col></Col>
                        <Col>
                          <Row justify={"center"}>
                            <Typography.Text>
                              {getDay(
                                dsNhomChiDinhPTTT?.[0]?.chiDinhDtos?.[0]
                                  ?.thoiGian
                              )}
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text strong>
                              Bác sĩ điều trị
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text type="secondary">
                              (Ký và ghi rõ họ tên)
                            </Typography.Text>
                          </Row>
                          <Row justify={"center"} style={{ marginTop: "48px" }}>
                            <Typography.Text strong>
                              {thongTinBN?.tenBacSiDieuTri}
                            </Typography.Text>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td
                        style={{ borderCollapse: "collapse", height: "20px" }}
                      ></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </>
          ) : null}
        </div>
        <div className="print-containter" style={{ display: "none" }}>
          <div ref={printRef2} className="print">
            <div id="print-content">
              <div className="xetNghiem" id="xn"></div>
              <div className="cdha" id="cdha"></div>
              <div className="pttt" id="pttt"></div>
            </div>
          </div>
        </div>
        <Row
          justify={"end"}
          className="footer"
          style={{ gap: "4px", marginTop: "8px" }}
        >
          <Button danger onClick={closeModal}>
            Hủy
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  In
                </Button>
              );
            }}
            content={() => cloneToPrint()}
            onAfterPrint={closeModal}
            bodyClass="phieu-chi-dinh-noi-tru"
          />
        </Row>
      </div>
    </Row>
  );
};
export default PhieuChiDinhXetNghiem;
